import { graphql } from "@/lib/gql/__generated__/gql";

export const VoucherI18n_EditPage_Query = graphql(`
	query VoucherI18n_EditPage($hotelID: ID!, $voucherID: ID!, $lang: LangCode!) {
		voucherI18n(hotelID: $hotelID, voucherID: $voucherID, lang: $lang) {
			id
			lang
			hotelID
			voucherID
			name
			description
		}
	}
`);
